/**
 * router.OnError時重新導向所需資料
 * @returns {Object}
 */
const state = () => ({
    targetPath: null,
    tryReload: null
});

const actions = {};

const getters = {};

const mutations = {
    /**
     * 設定目標網址
     * @param {*} state
     * @param {*} payload
     */
    setTargetPath(state, payload) {
        state.targetPath = payload;
    },
    /**
     * 控制只能reload一次
     * @param {*} state
     * @param {*} payload
     */
    setTryReload(state, payload) {
        state.tryReload = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
